module.exports = __webpack_public_path__ + "img/investor_huobi@2x.dcc075f2.png";